import axios from 'axios'
import config from '@/config'
import {axiosWrapper} from '@/shared/api.utils'

const colorsModule = {
  namespaced: true,
  state: {
  },
  mutations: {},
  actions: {
    async loadColors (context, companyId) {
      return axiosWrapper(axios.get(`${config.url}/company/${companyId}/get-carrier-colors/`))
    },
    async updateColor (context, payload) {
      return axiosWrapper(
        axios.put(`${config.url}/company/${payload.companyId}/update-carrier-color/${payload.colorSlug}/`, {new_value: payload.newValue}))
    }
  },
  getters: {},
}

export default colorsModule
